import { factoryService, postJsonRequest } from '@chilecompra/react-kit/requests'

import { REACT_APP_API_PRINCIPAL_URL } from '../configs/settings/environment'

/**
 * To validate a google recaptcha token enterprise with backend service
 */
export const verifyGoogleRecaptchaToken = factoryService(({ token }) => {
  const body = {
    aplicativo: 'consulta-mercado', // always-bot, always-human, consulta-mercado
    token
  }

  return postJsonRequest(`${REACT_APP_API_PRINCIPAL_URL}/v2/recaptcha/verifyCaptcha`, { body })
})
